module.exports = __webpack_public_path__ + "img/video-camera.16cc5d28.svg";